import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { SubscriptionLike } from 'rxjs';
import { environment } from '../../environments/environment';
import { SessionService } from '../Services/session.service';
import { ApiAboutService } from '../Services/api-about.service';
import { dashboardRoute } from '../route-names';

export const backButtonConfirmationModalSelector = 'app-back-button-confirmation-modal';

/** Redirects the back button to the welcome page, and add a warning */
@Component({
    selector: backButtonConfirmationModalSelector,
    templateUrl: './back-button-confirmation-modal.component.html',
    styleUrls: ['./back-button-confirmation-modal.component.scss'],
    standalone: false
})
export class BackButtonConfirmationModalComponent implements OnInit, OnDestroy {

  readonly modalId = 'back-button-confirmation-modal';
  readonly cancelButtonId = 'back-button-confirmation-modal-close-button';
  readonly confirmButtonId = 'back-button-confirmation-modal-confirm-button';
  readonly dialogElementIsSupported = ('HTMLDialogElement' in window) &&
    HTMLDialogElement !== undefined;

  @ViewChild('dialog')
  private dialog?: ElementRef<HTMLDialogElement>;
  private locationSubscription?: SubscriptionLike;

  returnText: string = $localize`You will not be able to return to this screen.`;

  constructor(
    private readonly location: Location,
    private readonly router: Router,
    private readonly session: SessionService,
    private readonly about: ApiAboutService
  ) {}

  ngOnInit(): void {
    if (this.dialogElementIsSupported) {
      this.location.go(this.location.path());
      this.locationSubscription = this.location.subscribe(() => {
        if(this.about.hasDashboard) {
          this.returnText = $localize`You will lose any unsubmitted progress.`;
        }
        this.location.go(this.location.path());
        if (!this.dialog?.nativeElement?.open) {
          this.dialog?.nativeElement?.showModal();
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.locationSubscription?.unsubscribe();
  }

  cancel(): void {
    this.dialog?.nativeElement?.close();
    this.location.go(this.location.path());
  }

  confirm(): Promise<boolean> {
    if(this.about.hasDashboard){
      return this.router.navigate(dashboardRoute);
    } else {
      if(this.session.activeSessionCheck()) {
        this.session.endSession();
      }
      return this.router.navigate(environment.startRoute);
    }
  }
}
